export function ensureError(err: unknown, defaultErrorMsg?: string): Error {
  if (err instanceof Error) {
    return err;
  }

  return new Error(defaultErrorMsg);
}
